import getCtaCount from '@/api/getCtaCount';
import getNotifications_v2 from '@/api/getNotifications_v2';
import getNotificationSettings from '@/api/getNotificationSettings';
import { useQuery } from '@tanstack/react-query';

function useNotifications() {
  const notificationsQuery = useQuery({
    queryKey: ['notifications_header'],
    queryFn: () => getNotifications_v2(),
  });
  return notificationsQuery;
}

function useUnreadNotificationsCount() {
  const notificationsQuery = useNotifications();
  const unreadNotificationsCount = notificationsQuery.data?.filter(
    notification => notification.status === false
  ).length;
  return unreadNotificationsCount ?? 0;
}

function useCtaCount() {
  const ctaCountQuery = useQuery({
    queryKey: ['cta_count'],
    queryFn: () => getCtaCount(),
  });
  return ctaCountQuery;
}

function useNotificationSettings() {
  const notificationSettingsQuery = useQuery({
    queryKey: ['notification_settings'],
    queryFn: getNotificationSettings,
  });
  return notificationSettingsQuery;
}

export { useNotifications, useCtaCount, useUnreadNotificationsCount, useNotificationSettings };
